export default __webpack_public_path__ + "static/media/sme.e2365527.jpg";